import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const ContractRecordsSkeleton: React.FC = () => (
  <div className="space-y-2">
    {Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="h-8 w-full" />)}
  </div>
)
export default ContractRecordsSkeleton
